<template>
  <GestionExclusiones />
</template>
<script>
import GestionExclusiones from "./components/GestionExclusiones";
export default {
  components: { GestionExclusiones },
};
</script>